import i18n from '@/i18n';
import { TileData } from './types';

export const defaultStory: TileData[] = [
  {
    id: 'introduction',
    title: i18n.t('onboarding.welcomeTour.introduction.title'),
    text: i18n.t('onboarding.welcomeTour.introduction.text'),
    illustrationId: 'heroes',
    buttonTitle: i18n.t('onboarding.welcomeTour.introduction.buttonTitle'),
  },
  {
    id: 'prelude',
    subtitle: i18n.t('onboarding.welcomeTour.prelude.subtitle'),
    buttonTitle: i18n.t('onboarding.welcomeTour.prelude.buttonTitle'),
    buttonDisplayClass: 'show-for-small',
    controlsDisplayClass: 'hide-for-small',
    controlButtons: [{ direction: 'forward', type: 'iconButton' }],
  },
  {
    id: 'documents',
    subtitle: i18n.t('onboarding.welcomeTour.documents.subtitle'),
    text: i18n.t('onboarding.welcomeTour.documents.text'),
    buttonTitle: i18n.t('onboarding.welcomeTour.documents.buttonTitle'),
    footerText: i18n.t('onboarding.welcomeTour.documents.footerText'),
    illustrationId: 'catch-up-documents',
    controlButtons: [
      {
        direction: 'forward',
        type: 'inline',
        text: i18n.t('onboarding.welcomeTour.documents.sendLater'),
        bold: true,
      },
    ],
  },
  {
    id: 'addCalendar',
    subtitle: i18n.t('onboarding.welcomeTour.addCalendar.subtitle'),
    text: i18n.t('onboarding.welcomeTour.addCalendar.text'),
    buttonTitle: i18n.t('onboarding.welcomeTour.addCalendar.buttonTitle'),
    illustrationId: 'add-to-calendar',
    controlButtons: [
      {
        direction: 'backward',
        type: 'inline',
        text: i18n.t('onboarding.welcomeTour.addCalendar.backToDocuments'),
        shortText: i18n.t('onboarding.welcomeTour.addCalendar.back'),
      },
      {
        direction: 'forward',
        type: 'inline',
        text: i18n.t('onboarding.welcomeTour.addCalendar.addLater'),
        bold: true,
      },
    ],
  },
  {
    id: 'ending',
    title: i18n.t('onboarding.welcomeTour.ending.title'),
    subtitle: i18n.t('onboarding.welcomeTour.ending.subtitle'),
    buttonTitle: i18n.t('onboarding.welcomeTour.ending.buttonTitle'),
  },
];
